export enum ETypOsoby {
    FYZICKAOSOBA = 'F',
    PRAVNICKAOSOBA = 'P'
}
